export class VerifyEmailRequest {
  constructor(
    public captcha: string | null,
    public email: string | null,
    public firstName: string | null,
    public lastName: string | null
  ) {}
}
